(function () {
  function swiperInit() {
    subSliderInit(true);
    sliderInit(true);
    // NegoStore (perf 09.10.2026): popupSliderInit nu mai ruleaza aici. Swiper-ul de zoom
    // (fereastra inca ascunsa) intra in long task-ul de ~170 ms de la DCL (telefon, CPU 4x);
    // acum porneste la prima deschidere, in ProductModal.show() din main-product.liquid.
  }

  document.addEventListener("shopify:section:load", function (e) {
    swiperInit();
  });

  swiperInit();
})();
